import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

type Props = SvgIconProps;

const UsersIcon: React.FC<Props> = (props) => {
  return (
    <SvgIcon viewBox="0 0 21 21" {...props}>
      <path d="M0.833008 20.1665C0.833008 18.2216 1.60562 16.3563 2.98089 14.9811C4.35616 13.6058 6.22142 12.8332 8.16634 12.8332C10.1113 12.8332 11.9765 13.6058 13.3518 14.9811C14.7271 16.3563 15.4997 18.2216 15.4997 20.1665H0.833008ZM8.16634 11.9165C5.12759 11.9165 2.66634 9.45525 2.66634 6.4165C2.66634 3.37775 5.12759 0.916504 8.16634 0.916504C11.2051 0.916504 13.6663 3.37775 13.6663 6.4165C13.6663 9.45525 11.2051 11.9165 8.16634 11.9165ZM14.9158 13.9634C16.3179 14.3238 17.5707 15.1174 18.4956 16.2311C19.4206 17.3448 19.9706 18.722 20.0674 20.1665H17.333C17.333 17.774 16.4163 15.596 14.9158 13.9634ZM13.0613 11.8771C13.8295 11.19 14.4438 10.3484 14.864 9.40736C15.2842 8.46631 15.5008 7.4471 15.4997 6.4165C15.5016 5.16385 15.1812 3.93176 14.5693 2.83875C15.6075 3.04738 16.5415 3.6091 17.2124 4.42843C17.8834 5.24777 18.2499 6.27417 18.2497 7.33317C18.2499 7.98626 18.1106 8.63187 17.8409 9.22671C17.5713 9.82155 17.1777 10.3519 16.6864 10.7822C16.195 11.2125 15.6174 11.5328 14.9922 11.7216C14.367 11.9104 13.7087 11.9634 13.0613 11.8771Z" />
    </SvgIcon>
  );
};

export default UsersIcon;
